import { render } from "./EndContainer.vue?vue&type=template&id=f7a01dd4"
import script from "./EndContainer.vue?vue&type=script&lang=js"
export * from "./EndContainer.vue?vue&type=script&lang=js"

import "./EndContainer.vue?vue&type=style&index=0&id=f7a01dd4&lang=scss"
script.render = render

export default script